export default __webpack_public_path__ + "e07b03e57c40c5733d6279c51acb24a9.png";